var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name == 'PageNotFound')?[_c('router-view')]:[(_vm.showHeader)?_c('app-header'):_vm._e(),_c('div',{class:_vm.showHeader ? "admin-page-content" : "",attrs:{"id":"wrapper"}},[(_vm.showHeader)?_c('sidebar'):_vm._e(),_c('router-view'),_c('app-footer')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }